angular.module('bmsApp.sm.quote').factory('SMJobDocumentSvc', function ($rootScope, $http, $log, $window, $q, CRUDSvc, $modal) {
	return {
		delete: function (params) {
			return CRUDSvc.post('api/sm/job/document/delete', params);
		}
	}
});




